import { Row, Space, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';
import type { ReconDetailsCardCostRecord } from '@melio/payments-recon-api-client-ts';
import { theme } from '@tools/ui-utils/theme.util';
import {
  AmountWithCurrency,
  DateSnippet
} from '../../../../components/snippets';
import FundsDirection from '../fundsDirection';

const Label = styled(Typography.Text)`
  display: block;
  margin-bottom: 4px;
  color: ${theme.colors.verificationTask.isRevived};
`;

export const CardCostRecordDetails: React.FC<{
  cardCostRecord: ReconDetailsCardCostRecord;
}> = ({ cardCostRecord }) => {
  return (
    <Space direction="vertical" size={20}>
      <div>
        <Label>Reco ID</Label>
        {cardCostRecord.recordId}
      </div>

      <div>
        <Label>Reconciliation Status</Label>
        {cardCostRecord.reconciliationStatus}
      </div>

      <div>
        <Label>External ID</Label>
        {cardCostRecord.externalId}
      </div>

      <div>
        <Label>Fee Record Type</Label>
        {cardCostRecord.feeRecordType}
      </div>

      <div>
        <Label>Fee Source</Label>
        {cardCostRecord.feeSource}
      </div>

      <div>
        <Label>Settlement Date</Label>
        {cardCostRecord.settlementDate ? (
          <DateSnippet
            date={cardCostRecord.settlementDate.toString()}
            format="MMM DD, YYYY"
          />
        ) : null}
      </div>

      <div>
        <Label>Amount</Label>
        <Row>
          {!!cardCostRecord.direction && (
            <>
              <FundsDirection direction={cardCostRecord.direction} />
              &nbsp;&nbsp;
            </>
          )}
          <AmountWithCurrency amount={cardCostRecord.amount} />
        </Row>
      </div>

      <div>
        <Label>Bank</Label>
        {cardCostRecord.bank}
      </div>

      <div>
        <Label>MID</Label>
        {cardCostRecord.mid}
      </div>

      <div>
        <Label>Card Processor</Label>
        {cardCostRecord.cardProcessor}
      </div>

      {!!cardCostRecord.settlementRecordId && (
        <div>
          <Label>Settlement Record ID</Label>
          {cardCostRecord.settlementRecordId}
        </div>
      )}

      {!!cardCostRecord.classification && (
        <div>
          <Label>Classification</Label>
          {cardCostRecord.classification}
        </div>
      )}

      {!!cardCostRecord.comment && (
        <div>
          <Label>Comment</Label>
          {cardCostRecord.comment}
        </div>
      )}

      {!!cardCostRecord.reason && (
        <div>
          <Label>Reason</Label>
          {cardCostRecord.reason}
        </div>
      )}
    </Space>
  );
};
